import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  NConfigProvider,
  darkTheme,
  useOsTheme,
  NMessageProvider,
  NDialogProvider,
} from "naive-ui";
import Layout from "@/views/layout/index.vue";
import type { GlobalThemeOverrides } from "naive-ui";
import { computed } from "vue";
import { useMainStore } from "./store/main";
import hljs from "highlight.js";
import xml from "highlight.js/lib/languages/xml";
import java from "highlight.js/lib/languages/java";
import md from "highlight.js/lib/languages/markdown";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

hljs.registerLanguage("xml", xml);
hljs.registerLanguage("java", java);
hljs.registerLanguage("md", md);
const store = useMainStore();
// overTheme
const lightThemeOverrides: GlobalThemeOverrides = {
  common: {
    primaryColor: "#ff6a00",
    primaryColorHover: "#ff6a00",
  },
};

const darkThemeOverrides: GlobalThemeOverrides = {
  common: {
    primaryColor: "#ff6a00",
    primaryColorHover: "#ff6a00",
  },
  Divider: {
    color: "#4a5053",
  },
  Layout: {
    siderBorderColor: "#4a5053",
    siderColor: "#1b1f23",
    color: "#1b1f23",
    footerColor: "#262a2d",
  },
};

// dark
// @ts-ignore
store.toggleTheme(useOsTheme());
const theme = computed(() => {
  if (store.theme === "dark") {
    return darkTheme;
  }
  return null;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NConfigProvider), {
    theme: _unref(theme),
    "theme-overrides": _unref(theme) ? darkThemeOverrides : lightThemeOverrides,
    hljs: _unref(hljs),
    class: _normalizeClass(_unref(theme) ? 'dark-theme' : 'light-theme')
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(NDialogProvider), null, {
        default: _withCtx(() => [
          _createVNode(_unref(NMessageProvider), null, {
            default: _withCtx(() => [
              _createVNode(Layout)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["theme", "theme-overrides", "hljs", "class"]))
}
}

})